module.exports = "/assets/data/3dcf995ac11a55cedf9b47b52cff051c-DL6.data.json";